"use client";
import { useCallback, useEffect, useRef, useState } from "react";
import { LogOut, Pause, Play, Repeat2, RotateCcw } from "lucide-react";
import { useTimelineStore } from "@/stores/timelineStore";

const formatTime = (seconds: number) => `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${(seconds % 60).toFixed(3).padStart(6, "0")}`;

export function FullscreenControls() {
  const [visible, setVisible] = useState(true);
  const timer = useRef<number | null>(null);
  const currentTime = useTimelineStore((state) => state.currentTime);
  const duration = useTimelineStore((state) => state.duration);
  const playing = useTimelineStore((state) => state.playing);
  const loop = useTimelineStore((state) => state.loop);
  const togglePlaying = useTimelineStore((state) => state.togglePlaying);
  const toggleLoop = useTimelineStore((state) => state.toggleLoop);
  const restart = useTimelineStore((state) => state.restart);
  const reveal = useCallback(() => {
    setVisible(true);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setVisible(false), 3000);
  }, []);
  useEffect(() => {
    timer.current = window.setTimeout(() => setVisible(false), 3000);
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.code === "Space") { event.preventDefault(); togglePlaying(); reveal(); }
      if (event.key.toLowerCase() === "r") { event.preventDefault(); restart(); reveal(); }
    };
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("mousemove", reveal);
    return () => { window.removeEventListener("keydown", onKeyDown); window.removeEventListener("mousemove", reveal); if (timer.current) window.clearTimeout(timer.current); };
  }, [restart, reveal, togglePlaying]);
  return <div className={`fullscreen-controls ${visible ? "visible" : "hidden"}`} onMouseEnter={reveal}>
    <button onClick={restart} title="Restart (R)"><RotateCcw size={16} /></button>
    <button className="fullscreen-play" onClick={togglePlaying} title="Play / Pause (Space)">{playing ? <Pause size={19} /> : <Play size={19} />}</button>
    <span className="fullscreen-time">{formatTime(currentTime)} <i>/</i> {formatTime(duration)}</span>
    <button className={loop ? "active" : ""} onClick={toggleLoop} title="Loop"><Repeat2 size={16} /></button>
    <button onClick={() => void document.exitFullscreen()} title="Exit fullscreen (Esc)"><LogOut size={16} /></button>
  </div>;
}
